module.exports = __webpack_public_path__ + "img/0a355c3ed6091162ae942c8e29da6694.jpg";